<template>
  <div class="container">

    <div class="progress-container">
      <div class="progress" id="progress"></div>
      <router-link :to="{name: 'create-tmz-step-first'}" v-if="step === 0">
        <div class="circle active" @click="firstStepTrigger">
          1
        </div>
      </router-link>
      <router-link :to="{name: 'view-tmz-step-first', params: {id: tmzId}}" v-if="step >= 1" ref="step1" data-tooltip="Востребованный ликвид">
        <div  class="circle active" @click="firstStepTrigger">
          1
        </div>
      </router-link>

      <router-link :to="{name: 'view-tmz-step-first', params: {tmzId: tmzId}}" v-if="step === 2">
        <div class="circle active" @click="secondStepTrigger">2</div>
      </router-link>
      <router-link :to="{name: 'view-tmz-step-second', params: {id: tmzId}}" v-if="step >= 3" ref="step2" data-tooltip="Невостребованный ликвид">
        <div class="circle active" @click="secondStepTrigger">2</div>
      </router-link>

      <router-link :to="{name: 'view-tmz-step-second', params: {tmzId: tmzId}}" v-if="step === 4">
        <div class="circle active" @click="thirdStepTrigger">3</div>
      </router-link>
      <router-link :to="{name: 'view-tmz-step-third', params: {id: tmzId}}" v-if="step >= 5" ref="step3" data-tooltip="Неликвид">
        <div class="circle active" @click="thirdStepTrigger">3</div>
      </router-link>

      <!-- <router-link :to="{name: 'view-tmz-step-four', params: {id: tmzId}}" v-if="step >= 6" ref="step3" data-tooltip="Динамика остатков">
        <div class="circle active" @click="thirdStepTrigger">4</div>
      </router-link> -->
    </div>

<!--    <div class="progress-container">-->
<!--      <div class="progress" id="progress"></div>-->
<!--      <div class="circle active" @click="firstStepTrigger">-->
<!--        <router-link :to="{name: 'create-tmz-step-first'}" v-if="step === 0">1</router-link>-->
<!--        <router-link :to="{name: 'view-tmz-step-first', params: {id: tmzId}}" v-if="step >= 1" ref="step1">1</router-link>-->
<!--      </div>-->
<!--      <div class="circle active" @click="secondStepTrigger">-->
<!--        <router-link :to="{name: 'create-tmz-step-second', params: {tmzId: tmzId}}" v-if="step === 1">2</router-link>-->
<!--        <router-link :to="{name: 'view-tmz-step-second', params: {id: tmzId}}" v-if="step >= 2" ref="step2">2</router-link>-->
<!--      </div>-->
<!--      <div class="circle active" @click="thirdStepTrigger">-->
<!--        <router-link :to="{name: 'create-tmz-step-third', params: {tmzId: tmzId}}" v-if="step === 2">3</router-link>-->
<!--        <router-link :to="{name: 'view-tmz-step-third', params: {id: tmzId}}" v-if="step >= 3" ref="step3" >3</router-link>-->
<!--      </div>-->
<!--    </div>-->

    <!--    <button class="step-btn" id="prev" @click="prevStep()" >Назад</button>-->
    <!--    <button class="step-btn" id="next" @click="nextStep()">Вперед</button>-->


  </div>
</template>

<script>
export default {
  name: "StepHeader",
  data() {
    return {
      currentStep: '',
      circles: 0
    }
  },
  props: ['tmzId', 'step'],
  methods: {
    firstStepTrigger() {
      this.$store.dispatch('updateCurrentStep', 1)
    },
    secondStepTrigger() {
      this.$store.dispatch('updateCurrentStep', 2)
    },
    thirdStepTrigger() {
      this.$store.dispatch('updateCurrentStep', 3)
    },
    nextStep() {

      if (this.currentStep == 1) {
        this.currentStep++;
        this.$store.dispatch('updateCurrentStep', this.currentStep)
        this.$router.push({name: 'view-tmz-step-second', params: {id: this.tmzId}}).catch(() => {
        });
      } else if (this.currentStep == 2) {
        this.currentStep++;
        this.$store.dispatch('updateCurrentStep', this.currentStep)
        this.$router.push({name: 'view-tmz-step-third', params: {id: this.tmzId}}).catch(() => {
        });
      } else {
        this.$router.push({name: 'view-tmz-step-first', params: {id: this.tmzId}}).catch(() => {
        });
      }

      const circles = this.circleSelector;

      if (this.currentStep > circles.length) {
        this.currentStep = circles.length
      }


      this.updateSteps()
    },
  },
  computed: {
    circleSelector() {
      return document.querySelectorAll('.circle')
    },
    progressBar() {
      return document.querySelector('#progress')
    }
  },
}
</script>

<style scoped>
.step-header {
  display: flex;
  justify-content: center;
  align-items: center;
}

a {
  color: black;
  text-decoration: none;
  margin: 20px;
}

.container {
  text-align: center;
}

.progress-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 350px;
  margin: 1rem auto;
  max-width: 100%;
}

.progress-container::before {
  content: "";
  /* background: #bdbdbd; */
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 4px;
  width: 100%;
  z-index: -1;
  transition: 0.4s ease;
}

.progress {
  background: #36429E;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 4px;
  width: 0%;
  z-index: -1;
  transition: 0.4s ease;
}


.circle {
  background-color: #fff;
  color: #999;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  border: 3px solid #b2bec3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease;
  cursor: pointer;
}

.circle.active {
  border-color: #36429E;
}

.step-btn {
  background-color: #36429E;
  color: #fff;
  border-radius: 6px;
  border: 0;
  cursor: pointer;
  padding: 8px 30px;
  margin: 5px;
  font-size: 14px;
}

.step-btn:focus {
  outline: 0;
}

.step-btn:active {
  transform: scale(0.97);
}

.step-btn:disabled {
  background-color: #bdbdbd;
  cursor: not-allowed;
}

*[data-tooltip] {
  position: relative;
}

*[data-tooltip]::after {
  content: attr(data-tooltip);

  position: absolute;
  top: 50px;
  right: -50px;
  width: 150px;

  pointer-events: none;
  opacity: 0;
  -webkit-transition: opacity 0.15s ease-in-out;
  -moz-transition: opacity 0.15s ease-in-out;
  -ms-transition: opacity 0.15s ease-in-out;
  -o-transition: opacity 0.15s ease-in-out;
  transition: opacity 0.15s ease-in-out;

  display: block;
  font-size: 12px;
  line-height: 16px;
  background: #fefdcd;
  padding: 2px 2px;
  border: 1px solid #c0c0c0;
  box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.4);
}

*[data-tooltip]:hover::after {
  opacity: 1;
}

</style>